module.exports = __webpack_public_path__ + "img/gq1.9ec83003.png";